module.exports = __webpack_public_path__ + "img/facebook-sm.84b12199.svg";